import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { currentUser as currentUserSelector } from 'selectors/auth.selector';

const AuthRoute = ({ element }) => {
  const currentUser = useSelector((state) => {
    return currentUserSelector(state);
  });

  return currentUser ? element : <Navigate to="/auth/login" replace />;
};

AuthRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default AuthRoute;
